// theme.ts
import { createTheme, responsiveFontSizes } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    buttonLarge: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    buttonLarge?: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    buttonLarge: true;
  }
}

// Erstelle ein Basis-Theme
let theme = createTheme({
  palette: {
    primary: { main: "#dd7a2f" },
    secondary: { main: "#000000" },
  },
  typography: {
    fontFamily: "Klavika Light",
    // Basis-Typografie definieren
    h1: {
      fontSize: "2.5rem",  // Wird durch responsiveFontSizes angepasst
    },
    h2: {
      fontSize: "2rem",
    },
    body1: {
      fontSize: "1.0rem",
    },
    button: {
        fontSize: "1.0rem",
    },
    buttonLarge: {
      fontSize: "1.5rem", // Diese wird auch angepasst
    },
  },
  // Breakpoints definieren
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  // Zentrales Spacing-System für konsistente Abstände
  spacing: (factor: number) => `${0.5 * factor}rem`,
});

// Automatische Anpassung der Schriftgrößen
theme = responsiveFontSizes(theme, {
  breakpoints: ['xs', 'sm', 'md', 'lg', 'xl'],
  factor: 2, // Stärke der Anpassung (höher = stärkere Reduktion auf mobilen Geräten)
});

export { theme };
